
// Core
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';

// Third-Party Modules
import { Angulartics2Module, Angulartics2Segment } from 'angulartics2';
import { OAuthModule } from 'angular-oauth2-oidc';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

// Internal Modules
import { ReportModule } from './report/modules/report.module';
import { AppRoutingModule } from './routing/modules/routing.module';
import { SharedModule } from './shared/modules/shared.module';

// Routing
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';

// Services
import { AppSettings } from './settings/app.settings';
import { AuthService } from './auth/services/auth.service';
import { AuthGuardService } from './auth/services/auth-guard.service';
import { EventsService } from './events/services/events.service';
import { GlobalSettingsService } from './settings/services/global-settings.service';
import { PermissionService } from './auth/services/permission.service';
import { SettingsService, settingsServiceFactory } from './settings/services/settings.service';

// Application
import { AppComponent } from './app.component';
import { AppHeaderComponent } from './header/components/header.component';
import { AppFooterComponent } from './footer/components/footer.component';

// Dashboard
import { AppDashboardComponent } from './dashboard/components/dashboard/dashboard.component';
import { DashboardTileComponent } from './dashboard/components/tile/dashboard-tile.component';

// Auth
import { UnauthorisedComponent } from './auth/components/login-unauthorised.component';

// Settings
import { AdjustmentSettingsComponent } from './settings/components/settings-adjustments.component';
import { OutputSettingsComponent } from './settings/components/settings-output-options.component';
import { ReportSettingsComponent } from './settings/components/settings-report-options.component';
import { SettingsComponent } from './settings/components/settings.component';

import { ApplicationHttpInterceptor } from './http.interceptor';
import { PrivacyNoticeComponent } from './shared/components/privacy-notice/privacy-notice.component';

@NgModule({
  declarations: [
    AdjustmentSettingsComponent,
    AppComponent,
    AppDashboardComponent,
    AppFooterComponent,
    AppHeaderComponent,
    DashboardTileComponent,
    OutputSettingsComponent,
    ReportSettingsComponent,
    SettingsComponent,
    UnauthorisedComponent,
    BreadcrumbComponent,
    PrivacyNoticeComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    OAuthModule.forRoot(),
    ReportModule,
    Angulartics2Module.forRoot([ Angulartics2Segment ]),
    SharedModule,
    BsDropdownModule.forRoot()
  ],
  providers: [
    { 
      provide: HTTP_INTERCEPTORS, 
      useClass: ApplicationHttpInterceptor, 
      multi: true 
    },
    AppSettings,
    {
      provide: APP_INITIALIZER,
      useFactory: settingsServiceFactory,
      deps: [SettingsService, AppSettings, HttpClient],
      multi: true
    },
    AuthGuardService,
    AuthService,
    EventsService,
    GlobalSettingsService,
    PermissionService,
    SettingsService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}


// WEBPACK FOOTER //
// ./src/app/app.module.ts